// test2593
(2593 && 0);
